module.exports = window.initializeRemote('admin', {"WEBPACK_BUNDLE":true,"WEBPACK_BUILD":true,"BUILD_TARGET":"production"});